import React, { useContext } from "react";
import GithubContext from "../../context/github/githubContext";
import UserResultCard from "./UserResultCard";

const FeaturedSkeleton = () => (
  <div className="gf-results__grid">
    {Array.from({ length: 12 }, (_, i) => (
      <div key={i} className="gf-skeleton gf-skeleton--card" />
    ))}
  </div>
);

const FeaturedDevelopers = () => {
  const { featuredUsers, featuredLoading, insightLogin, setInsightLogin } =
    useContext(GithubContext);

  if (featuredLoading) {
    return (
      <section className="gf-featured" aria-labelledby="featured-heading" aria-busy="true">
        <h2 id="featured-heading" className="gf-section-title">
          Featured Developers
        </h2>
        <FeaturedSkeleton />
      </section>
    );
  }

  if (!featuredUsers?.length) return null;

  return (
    <section className="gf-featured" aria-labelledby="featured-heading">
      <h2 id="featured-heading" className="gf-section-title">
        Featured Developers
      </h2>
      <div className="gf-results__grid">
        {featuredUsers.map((u) => (
          <UserResultCard
            key={u.id}
            user={u}
            insightLogin={insightLogin}
            onSelectInsight={setInsightLogin}
          />
        ))}
      </div>
    </section>
  );
};

export default FeaturedDevelopers;
